/* OTF — the offer sheet. 22 Sep 2026.

   CEO: "yes do it and make sure its timing and place is perfect and
   intriguing." One sheet, once per shopper, revealing the first-order credit.

   ⚠ IT DOES NOT APPEAR ON PAGE LOAD. Loading a page and waiting shows you
   nothing, by design. Put something in the bag. (This is the first thing that
   confused the CEO on the review copy, along with the eligibility rule below.)

   THE TIMING, AND WHY IT IS THIS AND NOT ANYTHING ELSE.
   It fires on the FIRST ADD TO THE BAG, 900ms after the count changes.
   - Not on arrival. The photographs are what sell here; a modal over them
     interrupts the only thing doing the work, and it lands before the shopper
     has any reason to care about a discount.
   - Not at checkout. 33 shoppers reached checkout in the eight days to 22 Sep
     and 2 reached payment; putting a layer there adds one more thing to
     dismiss at the exact step that is already bleeding.
   - On the add, they have just CHOSEN something. The offer stops being an
     advert and becomes a fact about the thing in their hand. 900ms lets the
     theme's add-to-bag flight land first, so the two animations never collide.

   THE PLACE. It rises from the bottom, over its own scrim, with the bag's
   geometry (480px, 22px top corners, the same safe-area padding). This theme
   already rises sheets from the bottom for the bag, the quick view and the
   gallery, so a shopper has met this motion three times before they meet this.
   It reads as the shop, not as an advert dropped on top of it.

   IT NEVER COLLIDES WITH THE BAG. If the bag sheet is open (.fluid-bag.up)
   the sheet waits, and opens 420ms after the bag closes — we listen for the
   'fluidbag' event fluid-motion.js dispatches on document. Never two sheets.

   THE REVEAL BEAT is the one flourish: the sheet lands, and 220ms later the
   gold code scales in while the lotus takes one breath. Reduced motion gets
   neither. Nothing else moves.

   ONCE, EVER — UNLESS PREVIEW MODE IS ON. The flag lives in localStorage
   under the key the section hands over in data-key. In preview mode the
   section sends a FRESH key on every page load, so the sheet fires on every
   add; that is how the CEO looks at it without clearing site data. It can
   throw or come back empty in a private window, which only means the sheet
   may show twice — annoying, not harmful — so every read and write is
   wrapped and nothing depends on it.

   IT NEVER LIES ABOUT WHAT THE CODE IS WORTH. Three states, from the same
   thresholds the bag's goal line uses:
     under the minimum    -> how far away, no apply button
     the DEAD BAND        -> see below, no apply button
     everywhere else      -> the code, and an apply button

   ⚠ THE DEAD BAND, MEASURED 22 Sep. Free delivery in this shop is a delivery
   RATE, not a discount: 3.000 KD under 45, free at 45 and over. Shopify
   evaluates that rate on the total AFTER discounts — proven on a real cart,
   47.000 got free delivery, and applying HALA took it to 44.000 and the rate
   went back to 3.000. So between 45.000 and 47.999 a 3 KD code saves the
   shopper EXACTLY NOTHING: three off the flowers, three back on the van. In
   that band the sheet does not offer the code. It says: add a little and keep
   both. Change the credit or the free-delivery line and this band moves —
   both are settings on the section.

   ⚠ MONEY UNITS. /cart.js reports KWD in HUNDREDTHS, not fils: 35.000 KD
   comes back as 3500. Divide by 100. Measured, not assumed.

   It attaches from the OUTSIDE, like fluid-rv-sheet.js, fluid-sub.js,
   otf-sheet-locale.js, otf-slot-cutoff.js and otf-address-skip.js. Nothing in
   sections/fluid-bar.liquid is touched. */
(function () {
  var src = document.getElementById('otf-sheet-data');
  if (!src) return;

  var A = function (k) { return src.getAttribute(k); };

  /* the section decides the key: a fixed one normally, a fresh one every page
     load in preview mode, which is what re-arms the sheet for the CEO */
  var KEY = A('data-key') || 'otf_offer_sheet_v1';
  function seen() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function mark() { try { localStorage.setItem(KEY, '1'); } catch (e) { } }
  if (seen()) return;

  var MIN = parseInt(A('data-min'), 10);
  var FREE = parseInt(A('data-free'), 10);
  var AMT = parseInt(A('data-amount'), 10);
  var HREF = A('data-href');
  var DELAY = parseInt(A('data-delay'), 10) || 900;
  var T = {
    kick: A('data-t-kick'), pick: A('data-t-pick'),
    head: A('data-t-head'), ready: A('data-t-ready'),
    away: A('data-t-away'), both: A('data-t-both'),
    fine: A('data-t-fine'), cta: A('data-t-cta'),
    keep: A('data-t-keep'), close: A('data-t-close')
  };
  if (!MIN || !FREE || !AMT || !HREF) return;

  function money(m) { return (m / 100).toFixed(3); }

  var fired = false, waiting = false, wrap = null, lastFocus = null;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* the lotus, the same geometry as snippets/fluid-marklet */
  function markSvg() {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 100 100');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('class', 'os-mark');
    s.innerHTML = '<circle cx="50" cy="50" r="45.5" stroke-width="5"/>' +
      '<g transform="translate(50 52) scale(0.72) translate(-50 -61)" stroke-width="6.5" stroke-linejoin="round" stroke-linecap="round">' +
      '<path d="M50,78 C42.5,70 42,60 50,52 C58,60 57.5,70 50,78 Z" transform="rotate(-68 50 78)"/>' +
      '<path d="M50,78 C42.5,70 42,60 50,52 C58,60 57.5,70 50,78 Z" transform="rotate(68 50 78)"/>' +
      '<path d="M50,78 C41.5,68 41,52 50,42 C59,52 58.5,68 50,78 Z" transform="rotate(-34 50 78)"/>' +
      '<path d="M50,78 C41.5,68 41,52 50,42 C59,52 58.5,68 50,78 Z" transform="rotate(34 50 78)"/>' +
      '<path d="M50,78 C40,66 39.5,45 50,32 C60.5,45 60,66 50,78 Z"/>' +
      '<path d="M50,70 C45.5,62 45,50 50,43 C55,50 54.5,62 50,70 Z" stroke-width="6"/></g>';
    return s;
  }

  function close() {
    if (!wrap) return;
    wrap.classList.remove('is-up');
    var w = wrap;
    wrap = null;
    setTimeout(function () { if (w && w.parentNode) w.parentNode.removeChild(w); }, 420);
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { } }
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); }
  }

  function build(cart) {
    var sub = cart.items_subtotal_price;
    var lineText, canApply;

    if (sub < MIN) {
      lineText = T.away.replace('{amount}', money(MIN - sub));
      canApply = false;
    } else if (sub >= FREE && sub < FREE + AMT) {
      lineText = T.both.replace('{amount}', money(FREE + AMT - sub));
      canApply = false;
    } else {
      lineText = T.ready;
      canApply = true;
    }

    wrap = el('div', 'otf-osheet');
    var scrim = el('div', 'os-scrim');
    scrim.addEventListener('click', close);
    wrap.appendChild(scrim);

    var card = el('div', 'os-card');
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-modal', 'true');
    card.setAttribute('aria-label', T.head);
    wrap.appendChild(card);

    var x = el('button', 'os-x', T.close || '×');
    x.type = 'button';
    x.setAttribute('aria-label', T.close || 'Close');
    x.addEventListener('click', close);
    card.appendChild(x);

    card.appendChild(el('div', 'os-grab'));

    var top = el('div', 'os-top');
    top.appendChild(markSvg());
    top.appendChild(el('span', 'os-kick', T.kick));
    card.appendChild(top);

    /* name the bouquet they just chose — the reason this lands as a fact
       about their order rather than as an advert */
    var last = cart.items && cart.items.length ? cart.items[cart.items.length - 1] : null;
    if (last && last.product_title && T.pick) {
      card.appendChild(el('p', 'os-pick', T.pick.replace('{name}', last.product_title)));
    }

    card.appendChild(el('h2', 'os-head', T.head));

    var pill = el('div', 'os-code' + (canApply ? '' : ' is-dim'));
    pill.setAttribute('dir', 'ltr');
    pill.textContent = A('data-code');
    card.appendChild(pill);

    card.appendChild(el('p', 'os-line', lineText));
    if (T.fine) card.appendChild(el('p', 'os-fine', T.fine));

    if (canApply) {
      var a = el('a', 'os-cta fluid-press', T.cta);
      a.href = HREF;
      card.appendChild(a);
    } else {
      var b = el('button', 'os-cta fluid-press', T.keep);
      b.type = 'button';
      b.addEventListener('click', close);
      card.appendChild(b);
    }

    document.body.appendChild(wrap);
    mark();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        wrap.classList.add('is-up');
        setTimeout(function () { if (wrap) wrap.classList.add('is-lit'); }, 220);
      });
    });

    lastFocus = document.activeElement;
    var firstBtn = card.querySelector('.os-cta');
    if (firstBtn && firstBtn.focus) { try { firstBtn.focus({ preventScroll: true }); } catch (e) { } }
    document.addEventListener('keydown', onKey);
  }

  function tryOpen() {
    if (wrap) return;
    var bag = document.querySelector('.fluid-bag');
    if (bag && bag.classList.contains('up')) { waiting = true; return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.item_count) return;
        /* never offer a swap: Shopify allows one code per cart */
        if (c.discount_codes && c.discount_codes.length) { mark(); return; }
        if (wrap) return;
        build(c);
      })
      .catch(function () { });
  }

  document.addEventListener('fluidbag', function (e) {
    if (waiting && e && e.detail && !e.detail.open) {
      waiting = false;
      setTimeout(tryOpen, 420);
    }
  });

  /* the trigger: the bag count changing is the add. Reading the count rather
     than wrapping window.fetch keeps us out of the wrapper-ordering trap
     recorded in layout/theme.liquid. */
  var count = document.querySelector('.fluid-bagcount');
  if (!count || !window.MutationObserver) return;

  new MutationObserver(function () {
    if (fired) return;
    var n = parseInt((count.textContent || '').trim(), 10);
    if (!n || n < 1) return;
    fired = true;
    setTimeout(tryOpen, DELAY);
  }).observe(count, { childList: true, characterData: true, subtree: true });
})();
